export default __webpack_public_path__ + "static/media/exel.78069ab0.svg";